import React, { useState, useEffect } from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import SubNavigator from '../../components/SubNavigator';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../AppContext';
const staticLinks = [
  { path: '/Control/crawl-logs', label: '크롤링' },
  // { path: '/Control/time-control', label: '시간컨트롤' },
  // { path: '/Control/time-control', label: '팝업컨트롤' },
  // { path: '/Control/time-control', label: '그룹별극장컨트롤' },
];

export default function Control() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useApp();
  const [links, setLinks] = useState(staticLinks);

  useEffect(() => {
    // API 호출하여 테이블 이름 가져오기
    const fetchBoardTables = async () => {
      try {
        const response = await fetch('/request/getBoardTables?category=Control',{credentials:'include'}); // 실제 API 엔드포인트로 변경
        const data = await response.json();

        // 가져온 테이블 이름을 링크로 변환
        const dynamicLinks = data.map(table => ({
          path: `/Control/Board/${table.boardId}`,
          label: table.boardTitle // ants_ 및 _board 제거하여 보기 좋게 만듦
        }));

        // [제외극장 2026-08-08] 씨네체인(crm_unchain) 도메인에서만 노출. 영화거래소(crm_movie)엔 안 뜨게.
        // [문자발송내역 2026-09-01] 문자큐가 crm_unchain 단일소스라 같은 조건으로 노출.
        const domainLinks = (user?.domain === 'crm_unchain')
          ? [
              { path: '/Control/excluded-theaters', label: '제외극장 관리' },
              { path: '/Control/sms-history', label: '문자발송내역' },
            ]
          : [];
        // 동적 링크(리소스 등) 먼저, 크롤링 로그는 맨 아래에 표시
        setLinks([...dynamicLinks, ...staticLinks, ...domainLinks]);
      } catch (error) {
        console.error('Error fetching board tables:', error);
      }
    };

    fetchBoardTables();
  }, [user]);
  useEffect(()=>{
    if (links.length > 0 ) {
      if(location?.state?.fromNavigator===true){
        navigate(links[0].path);
      }
    }
  },[location,links])

  return (
    <div className="Control" style={{ display: 'flex', width: '100%', height: '100%' }}>
      <nav style={{ display: 'flex', flexDirection: 'row', backgroundColor: 'gray' }}>
        <SubNavigator links={links} />
      </nav>
      <main style={{ display: 'flex', width: '100%', background: '#fff' }}>
        <Outlet />
      </main>
    </div>
  );
}